import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/devApp/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/devApp/styles/animations.scss");
;
import(/* webpackMode: "eager" */ "/devApp/styles/directus.scss");
;
import(/* webpackMode: "eager" */ "/devApp/styles/backOfficeDiscussions.scss");
;
import(/* webpackMode: "eager" */ "/devApp/styles/react-paginate.scss");
;
import(/* webpackMode: "eager" */ "/devApp/styles/generic.scss");
